module.exports = __webpack_public_path__ + "static/before4-a87d9d9027ce4457de3ae20ba326d422.jpg";